import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
	icons: {
		iconfont: 'mdiSvg',
	},
	theme: {
		themes: {
			light: {
        primary: '#FF0000', // #E53935
        navbar: '#C4C4C4',
				error: '#ff8c00',
			},
		},
	},
});
